export default "__VITE_ASSET__GXteISoI__"